export const TRANSLATE_KEY = {
  addressGroup: 'filter.address_group',
  token: 'filter.token',
  network: 'filter.network',
};

export const TRANSLATE_PREFIX = 'commonComponent';
